// import createHistory from 'history/createBrowserHistory';
export const applicationHistory = require("history").createBrowserHistory()


// WEBPACK FOOTER //
// ./src/common/application-history.js